import React, { useEffect, useState } from "react";
import { mapScoreToLabel } from "./types";

const GradesPage = () => {
  const token = localStorage.getItem("token");
  const userId = localStorage.getItem("id");

  const [isLoading, setIsLoading] = useState(true);
  const [grades, setGrades] = useState<any[]>([]);

  useEffect(() => {
    fetch(`https://has-backend-c48d669d897f.herokuapp.com/student/evaluation/${userId}/modules/grades`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) throw new Error(`Error HTTP! Estado: ${response.status}`);
        return response.json();
      })
      .then((data) => {
        setGrades(data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.error("Error al cargar calificaciones:", err);
        setIsLoading(false);
      });
  }, []);

  return (
    <div className="min-h-screen w-full px-4 sm:px-8 py-8">
      <div className="flex flex-col items-start gap-6">
        <h2 className="font-playfair font-bold text-3xl sm:text-4xl mt-8">Calificaciones</h2>

        {isLoading ? (
          <p className="font-sourceSans">Cargando calificaciones...</p>
        ) : grades && grades.length > 0 ? (
          <div className="w-full flex flex-col gap-4 mt-4">
            <div className="hidden sm:flex flex-row justify-between px-4 sm:px-0 pb-2 font-bold font-sourceSans">
              <p>Módulo</p>
              <p>Calificación</p>
              <p>Semana</p>
            </div>
            {grades.map((grade, index) => (
              <div
                key={index}
                className="flex flex-col sm:flex-row sm:justify-between border-y border-gray-600 py-2 px-4 sm:px-0 text-sm sm:text-base"
              >
                <p className="font-sourceSans">{grade.moduleId.title}</p>
                <p className="font-sourceSans">
                  {grade.score === null ? (
                    "Estás cursando este módulo"
                  ) : (
                    <>
                      {mapScoreToLabel(grade.score).label} ({mapScoreToLabel(grade.score).range})
                    </>
                  )}
                </p>
                <p className="font-sourceSans">Semana {grade.moduleId.week}</p>
              </div>
            ))}
          </div>
        ) : (
          <p className="font-sourceSans px-4">No se encontraron calificaciones.</p>
        )}
      </div>
    </div>
  );
};

export default GradesPage;
